import type { SfmResourceProps } from 'src/AppScopes'
import { SfmResource } from 'src/AppScopes'

import { Create } from './Create'
import { Edit } from './Edit'
import { List } from './List'
import { Show } from './Show'

export function Resource(props: SfmResourceProps) {
  return (
    <SfmResource
      {...props}
      list={List}
      show={Show}
      create={Create}
      edit={Edit}
    />
  )
}
